import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Update+Profile+API

function updateProfile(profileData) {
    let url = '/api/users/profile';
    const { enableProfileAccountGroup = false } = Sephora.configurationSettings;
    const isUpdatingPassword = profileData.fragmentForUpdate === 'PASSWORD';

    if (enableProfileAccountGroup && cookieUtils.isRCPAccountAPIEnabled() && !isUpdatingPassword) {
        url = '/gway/v2/users/profiles';
    }

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify(profileData)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default updateProfile;
